import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import LTKHero from './components/LTKHero';
import LTKNiches from './components/LTKNiches';
import LTKHowItWorks from './components/LTKHowItWorks';
import LTKCTASection from './components/LTKCTA';
import LTKSources from './components/LTKSources';
import LTKAIDialog from './components/LTKAIDialog';
import LTKLeadCriteria from './components/LTKLeadCriteria';
import LTKComparison from './components/LTKComparison';
import LTKLaunch from './components/LTKLaunch';
import LTKFAQ from './components/LTKFAQ';

export default function LeadsTurnkey() {
  return (
    <main>
      <Navbar />

      {/* Экран 1: Hero */}
      <LTKHero />

      {/* Экран 2: Ниши и стоимость заявки */}
      <LTKNiches />

      {/* Экран 3: Как работаем — 4 шага */}
      <LTKHowItWorks />

      {/* Экран 4: CTA #1 */}
      <LTKCTASection
        title="Узнайте стоимость заявки для своей ниши"
        description="Оставьте заявку в Telegram. Разберём вашу нишу, средний чек, географию и подготовим предварительный расчёт."
        buttonText="Оставить заявку в Telegram"
        buttonHref="https://t.me/anna_aigam"
        bg="light"
        variant="card"
      />

      {/* Экран 5: Откуда берём клиентов */}
      <LTKSources />

      {/* Экран 6: Как ИИ пишет клиенту первым */}
      <LTKAIDialog />

      {/* Экран 7: CTA #2 */}
      <LTKCTASection
        title="Нужны клиенты, которых не придётся «дожимать» с нуля?"
        description="Напишите нам в Telegram. Настроим критерии целевого клиента, а ИИ возьмёт на себя первое касание, ответы и напоминания."
        buttonText="Получить заявки в Telegram"
        buttonHref="https://t.me/anna_aigam"
        bg="light"
        variant="card"
      />

      {/* Экран 8: Что считается квалифицированной заявкой */}
      <LTKLeadCriteria />

      {/* Экран 9: Почему это выгоднее обычной рекламы */}
      <LTKComparison />

      {/* Экран 10: Как запускаем работу — 5 шагов */}
      <LTKLaunch />

      {/* Экран 11: CTA #3 */}
      <LTKCTASection
        title="Рассчитаем стоимость заявки именно для вашего бизнеса"
        description="Напишите нам в Telegram. Покажем подходящую модель привлечения клиентов и ориентир по стоимости заявки."
        buttonText="Оставить заявку в Telegram"
        buttonHref="https://t.me/anna_aigam"
        bg="dark"
        variant="card"
      />

      {/* Экран 12: FAQ */}
      <LTKFAQ />

      {/* Экран 13: Финальный CTA */}
      <LTKCTASection
        title="Получайте заявки с подтверждённым интересом, а не просто контакты"
        description="Оставьте заявку в Telegram. ИИ начнёт работу с клиентами, а ваш отдел продаж будет получать готовые диалоги с потребностью и контактами."
        buttonText="Оставить заявку в Telegram"
        buttonHref="https://t.me/anna_aigam"
        bg="light"
        variant="card"
        footnote="Первая консультация и предварительный расчёт — бесплатно."
      />

      <Footer />
    </main>
  );
}